/*
 * Dreamy — comportements globaux : bandeau d'annonce, en-tête masqué au scroll vers le bas (filet après 8 px),
 * tiroirs <dialog>, lien « Gérer mes cookies », message d'ajout au panier.
 */
(function () {
  var D = (window.Dreamy = window.Dreamy || {});
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Message bref (role=status) */
  D.toast = function (text) {
    var el = document.getElementById('DreamyToast');
    if (!el || !text) return;
    el.textContent = text;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(D.toast.hide, 2800);
  };
  // Mobile : le message ne doit pas recouvrir l'en-tête du tiroir panier → retiré (en fondu) à son ouverture.
  D.toast.hide = function () {
    var el = document.getElementById('DreamyToast');
    if (el) el.classList.remove('is-visible');
  };

  /* Ouverture / fermeture des <dialog> (menu, test) avec blocage du défilement.
     Motion (prompt 4, D86) : ouverture par @starting-style (dreamy-motion.css), repli Web Animations sans support ;
     fermeture animée (classe is-closing), le <dialog> n'est fermé qu'à la fin (transitionend + garde-fou). */
  var M = function () {
    return D.motion && D.motion.enabled() ? D.motion : null;
  };
  D.openDialog = function (dialog, opener) {
    if (!dialog || dialog.open) return;
    dialog._opener = opener || document.activeElement;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.body.classList.add('dr-dialog-open');
    if (M() && !window.CSSStartingStyleRule) {
      var from = dialog.classList.contains('dr-drawer') ? { transform: 'translate3d(-100%,0,0)' } : { opacity: 0, transform: 'translate3d(0,24px,0)' };
      M().play(dialog, [from, { opacity: 1, transform: 'none' }], '--d-m', '--ease-out');
    }
  };
  D.closeDialog = function (dialog) {
    if (!dialog || !dialog.open || dialog._closing) return;
    var timer;
    var done = function (e) {
      if (e && (e.target !== dialog || e.propertyName !== 'transform')) return;
      clearTimeout(timer);
      dialog.removeEventListener('transitionend', done);
      dialog._closing = false;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      dialog.classList.remove('is-closing');
    };
    if (!M()) return done();
    dialog._closing = true;
    dialog.classList.add('is-closing');
    dialog.addEventListener('transitionend', done);
    timer = setTimeout(done, M().ms('--d-s') + 80);
  };
  // Échap : même fermeture animée (sinon le navigateur ferme sans animation, ce qui reste acceptable).
  document.addEventListener(
    'cancel',
    function (evt) {
      var dialog = evt.target;
      if (dialog.tagName !== 'DIALOG' || !M() || !evt.cancelable) return;
      evt.preventDefault();
      D.closeDialog(dialog);
    },
    true
  );
  function onDialogClosed(evt) {
    var dialog = evt.target;
    if (!dialog || dialog.tagName !== 'DIALOG') return;
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('dr-dialog-open');
    if (dialog._opener && document.contains(dialog._opener)) dialog._opener.focus({ preventScroll: true });
  }
  document.addEventListener('close', onDialogClosed, true);

  document.addEventListener('click', function (evt) {
    var opener = evt.target.closest('[data-dreamy-dialog-open]');
    if (opener) {
      evt.preventDefault();
      D.openDialog(document.getElementById(opener.getAttribute('data-dreamy-dialog-open')), opener);
      return;
    }
    var closer = evt.target.closest('[data-dreamy-dialog-close]');
    if (closer) {
      D.closeDialog(closer.closest('dialog'));
      return;
    }
    // Clic sur le voile (hors du contenu) : ferme le tiroir de menu.
    if (evt.target.tagName === 'DIALOG' && evt.target.classList.contains('dr-drawer')) {
      var r = evt.target.getBoundingClientRect();
      var inside = evt.clientX >= r.left && evt.clientX <= r.right && evt.clientY >= r.top && evt.clientY <= r.bottom;
      if (!inside) D.closeDialog(evt.target);
    }
    // Un lien du menu vers une ancre ou le test ferme le tiroir.
    var menuLink = evt.target.closest('.dr-drawer a');
    if (menuLink) D.closeDialog(menuLink.closest('dialog'));

    var cookies = evt.target.closest('[data-dreamy-cookie-prefs]');
    if (cookies && window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      evt.preventDefault();
      window.privacyBanner.showPreferences();
    }
  });

  /* Bandeau d'annonce : un message à la fois, pause au survol et au focus */
  function initAnnouncement() {
    var track = document.querySelector('[data-dreamy-announcement]');
    if (!track) return;
    var msgs = track.querySelectorAll('.dr-annonce__msg');
    if (msgs.length < 2) return;
    var i = 0;
    var paused = false;
    var delay = parseInt(track.getAttribute('data-interval'), 10) || 4000;
    ['mouseenter', 'focusin'].forEach(function (e) {
      track.addEventListener(e, function () {
        paused = true;
      });
    });
    ['mouseleave', 'focusout'].forEach(function (e) {
      track.addEventListener(e, function () {
        paused = false;
      });
    });
    setInterval(function () {
      if (paused || reduceMotion.matches || document.hidden) return;
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, delay);
  }

  /* En-tête : masqué au scroll vers le bas, réapparaît au scroll vers le haut */
  function initHeader() {
    var header = document.querySelector('.dr-header-section');
    if (!header) return;
    var lastY = window.scrollY;
    var ticking = false;
    // Filet inférieur en fondu dès 8 px de défilement (état .is-scrolled, voir dreamy-motion.css).
    header.classList.toggle('is-scrolled', lastY > 8);
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          var down = y > lastY && y > 160;
          header.classList.toggle('is-hidden', down && !document.body.classList.contains('dr-dialog-open'));
          header.classList.toggle('is-scrolled', y > 8);
          document.documentElement.classList.toggle('dr-header-hidden', down);
          lastY = y;
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  /* Ajout au panier : « Bonne nouvelle : votre nuit 1 approche. » */
  function initCartMessages() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'product-form' && window.dreamyConfig) D.toast(window.dreamyConfig.strings.added);
    });
  }

  /* Retour de /cart : ouverture du tiroir panier */
  function initCartRedirect() {
    var flag = null;
    try {
      flag = sessionStorage.getItem('dreamy_open_cart');
      sessionStorage.removeItem('dreamy_open_cart');
    } catch (e) {}
    if (!flag || !window.customElements) return;
    customElements.whenDefined('cart-drawer').then(function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.open) setTimeout(function () { drawer.open(); }, 50);
    });
  }

  function init() {
    initCartRedirect();
    initAnnouncement();
    initHeader();
    initCartMessages();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
